(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[76567],{

/***/ 17318:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/event/testseries/[testSeriesKey]",
      function () {
        return __webpack_require__(76602);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 41413:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Prodigy_ProdigyContainer; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(95934);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/hooks/reduxHooks.js + 1 modules
var reduxHooks = __webpack_require__(88738);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/redux/actions/courses.js
var courses = __webpack_require__(5861);
// EXTERNAL MODULE: ./src/components/Base/Dynamic/Dynamic.js + 2 modules
var Dynamic = __webpack_require__(28066);
// EXTERNAL MODULE: ./src/components/Container/Prodigy/index.jsx + 10 modules
var Prodigy = __webpack_require__(22888);
// EXTERNAL MODULE: ./src/styleConstants/index.js
var styleConstants = __webpack_require__(2080);
// EXTERNAL MODULE: ./src/stores/AppCommonData.jsx + 1 modules
var AppCommonData = __webpack_require__(83995);
// EXTERNAL MODULE: ./src/utils/boxShadowGenerator.js
var boxShadowGenerator = __webpack_require__(87312);
;// CONCATENATED MODULE: ./src/components/Container/Prodigy/PromotionalBanner.jsx

/* eslint-disable @next/next/no-img-element */ 




var Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "epzxxfv0",
    label: "Wrapper"
})("cursor:pointer;height:500px;width:1136px;margin:auto;margin-bottom:160px;@media only screen and (max-width:", styleConstants/* breakpoints.tablet */.AV.tablet, "){width:100%;padding:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";margin-bottom:80px;height:auto;}img{width:100%;height:100%;box-shadow:", (0,boxShadowGenerator/* default */.Z)(), ";border-radius:8px;}");
var PromotionalBanner = function(param) {
    var data = param.data;
    var isMobile = (0,AppCommonData/* useIsMobile */.dD)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
        onClick: data.permalink ? function() {
            return window.open(data.permalink);
        } : null,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
            src: isMobile ? data.mwImage : data.webImage,
            alt: "promotional-banner"
        })
    });
};
/* harmony default export */ var Prodigy_PromotionalBanner = (PromotionalBanner);
PromotionalBanner.propTypes = {
    data: prop_types_default().objectOf((prop_types_default()).any).isRequired
};

;// CONCATENATED MODULE: ./src/components/Container/Prodigy/ProdigyContainer.jsx

/* eslint-disable react-hooks/exhaustive-deps */ 








var GoalWiseTestSeries = (0,Dynamic/* default */.Z)(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 95498));
});
var ProdigyContainer_Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1u8fsbn0",
    label: "Wrapper"
})("width:100vw;margin-top:100px;@media only screen and (max-width:540px){width:100vw;overflow-x:hidden;margin-top:56px;}");
var ProdigyContainer = function(param) {
    var data = param.data;
    var goalList = (0,react.useRef)();
    var dispatch = (0,reduxHooks/* useDispatchToStore */.Ln)();
    var router = (0,next_router.useRouter)();
    var me = (0,reduxHooks/* useSelectorToStore */.nZ)(function(state) {
        return state.auth.me;
    });
    var testSeriesUIDs = data.testSeriesUIDs;
    (0,react.useEffect)(function() {
        if (me.username) {
            dispatch((0,courses/* checkCoursesEnrollStatus */.hP)(testSeriesUIDs));
        }
    }, [
        dispatch,
        me.username
    ]);
    var onEnrollNowClick = function() {
        // const offset = goalList.current?.offsetTop - 50;
        // window.scrollTo({
        //   top: offset,
        //   behaviour: 'smooth'
        // });
        document.getElementById("goalwise-testseries").scrollIntoView({
            behavior: "smooth",
            block: "center"
        });
    };
    var hasTests = Object.keys(data.tests).length > 0;
    var hasClasses = Object.keys(data.classes).length > 0;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ProdigyContainer_Wrapper, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prodigy/* ProdigyHeader */.aQ, {
                enrollNow: onEnrollNowClick,
                dataSet: data
            }),
            data.promotionalBanner1 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prodigy_PromotionalBanner, {
                data: data.promotionalBanner1
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prodigy/* HowToCrack */.j8, {
                enrollNow: onEnrollNowClick,
                dataSet: data
            }),
            hasTests && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GoalWiseTestSeries, {
                ref: goalList,
                items: data.tests,
                goalData: data.goalData,
                id: "goalwise-testseries",
                title: "Pick the right test for you",
                cardType: "test",
                data: data
            }),
            hasClasses && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GoalWiseTestSeries, {
                ref: goalList,
                items: data.classes,
                goalData: data.goalData,
                title: "Pick the right class for you",
                cardType: "class",
                id: "goalwise-testseries",
                data: data
            }),
            data.promotionalBanner2 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prodigy_PromotionalBanner, {
                data: data.promotionalBanner2
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prodigy/* StarPoints */.q2, {
                enrollNow: onEnrollNowClick,
                dataSet: data
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prodigy/* EducatorsList */.wR, {
                enrollNow: onEnrollNowClick,
                disable: router.route !== "prodigy"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prodigy/* ShareBlock */.Tw, {
                data: data.shareData
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prodigy/* AboutProdigy */.uy, {
                enrollNow: onEnrollNowClick,
                dataSet: data
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prodigy/* ProdigyFAQs */.rm, {
                enrollNow: onEnrollNowClick,
                dataSet: data
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Prodigy/* AppInstall */.rl, {})
        ]
    });
};
ProdigyContainer.propTypes = {
    data: prop_types_default().objectOf((prop_types_default()).any).isRequired
};
/* harmony default export */ var Prodigy_ProdigyContainer = (ProdigyContainer);


/***/ }),

/***/ 76602:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(47568);
/* harmony import */ var _unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(35944);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52420);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2962);
/* harmony import */ var _cont_Prodigy_ProdigyContainer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41413);
/* harmony import */ var _actions_quizzes__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43132);
/* harmony import */ var _utils_setupInitialProps__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(57714);
/* harmony import */ var _utils_route__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(56217);
/* harmony import */ var _layout_FreeLayout_FreeLayout__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(11559);
/* harmony import */ var _cont_App_PageReduxProviderWrapper__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(27300);













var TestSeries = function() {
    var query = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)().query;
    var testSeriesKey = query.testSeriesKey;
    var data = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(function(param) {
        var quizzes = param.quizzes;
        var ref;
        return ((ref = quizzes.testSeries) === null || ref === void 0 ? void 0 : ref[testSeriesKey]) || null;
    });
    var _metaData = data.metaData, metaData = _metaData === void 0 ? {} : _metaData;
    var title = metaData.title, description = metaData.description, ogImage = metaData.ogImage, twitterOgImage = metaData.twitterOgImage;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(next_seo__WEBPACK_IMPORTED_MODULE_4__/* .NextSeo */ .PB, {
                title: title,
                description: description,
                openGraph: {
                    title: title,
                    description: description,
                    images: [
                        {
                            url: ogImage
                        }
                    ]
                },
                twitter: {
                    images: [
                        {
                            url: twitterOgImage
                        }
                    ]
                }
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)("title", {
                    children: metaData.title
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(_cont_Prodigy_ProdigyContainer__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                data: data
            })
        ]
    });
};
TestSeries.pageInfo = {
    isMWebSupported: true,
    layoutOptions: {
        hideSearch: true,
        hideGoalSelector: true,
        hideLearnerMinutes: true,
        hideNudges: true,
        disableDarkMode: true,
        hideIntercom: true,
        hideFreshbot: true
    }
};
TestSeries.getInitialProps = (0,_utils_setupInitialProps__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var store, query, isServer, res, ref, testSeriesKey, response;
        return _unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    store = param.store, query = param.query, isServer = param.isServer, res = param.res;
                    ;
                    testSeriesKey = query.testSeriesKey;
                    if ((ref = store.getState().quizzes.testSeries) === null || ref === void 0 ? void 0 : ref[testSeriesKey]) {
                        _ctx.next = 9;
                        break;
                    }
                    _ctx.next = 6;
                    return store.dispatch((0,_actions_quizzes__WEBPACK_IMPORTED_MODULE_6__/* .fetchTestSeriesData */ .bW)(testSeriesKey));
                case 6:
                    response = _ctx.sent;
                    if (!(!response || response.error)) {
                        _ctx.next = 9;
                        break;
                    }
                    return _ctx.abrupt("return", (0,_utils_route__WEBPACK_IMPORTED_MODULE_8__/* .redirectToRoute */ .i)(isServer, res, "/404"));
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function(_) {
        return _ref.apply(this, arguments);
    };
}(), TestSeries.pageInfo);
/* harmony default export */ __webpack_exports__["default"] = (TestSeries);
TestSeries.Layout = _layout_FreeLayout_FreeLayout__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z;
TestSeries.Wrapper = _cont_App_PageReduxProviderWrapper__WEBPACK_IMPORTED_MODULE_10__["default"];


/***/ }),

/***/ 43132:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$2": function() { return /* binding */ createTest; },
/* harmony export */   "$k": function() { return /* binding */ fetchReviewStats; },
/* harmony export */   "Bt": function() { return /* binding */ fetchReviews; },
/* harmony export */   "GR": function() { return /* binding */ fetchEvalDashboardGoals; },
/* harmony export */   "Gs": function() { return /* binding */ assignEvaluation; },
/* harmony export */   "KN": function() { return /* binding */ fetchTestEvalDashStats; },
/* harmony export */   "QD": function() { return /* binding */ fetchMyUploads; },
/* harmony export */   "X1": function() { return /* binding */ fetchMyEvals; },
/* harmony export */   "Xf": function() { return /* binding */ assignUploader; },
/* harmony export */   "Zf": function() { return /* binding */ assignEvalutor; },
/* harmony export */   "aM": function() { return /* binding */ fetchQuizUploadDashboardGoals; },
/* harmony export */   "bW": function() { return /* binding */ fetchTestSeriesData; },
/* harmony export */   "cd": function() { return /* binding */ fetchEvaluatedCopies; },
/* harmony export */   "np": function() { return /* binding */ updateDashboardFilters; },
/* harmony export */   "so": function() { return /* binding */ submitCriteriaScore; },
/* harmony export */   "wB": function() { return /* binding */ uploadCSV; },
/* harmony export */   "xX": function() { return /* binding */ fetchReviewDashboardGoals; },
/* harmony export */   "yo": function() { return /* binding */ assignReview; }
/* harmony export */ });
/* unused harmony exports fetchMyQuizAttempts, updateSessionLanguage, fetchPostReviewNotifications, fetchGtpTestSeriesData */
/* harmony import */ var normalizr__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82677);
/* harmony import */ var _utils_paginateAction__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72894);
/* harmony import */ var _utils_api_helper_host__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54051);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94336);
/* harmony import */ var _schemas__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93010);





var fetchMyQuizAttempts = function(quizUid) {
    return function(dispatch) {
        return dispatch({
            type: quizTypes.FETCH_MY_QUIZ_ATTEMPTS,
            endpoint: "v1/quizzes/quiz/".concat(quizUid, "/leaderboard/?limit=200"),
            method: "get",
            quizUid: quizUid,
            schema: paginatorListSchema
        });
    };
};
var updateSessionLanguage = function(sessionUid, languageCode) {
    return function(dispatch) {
        return dispatch({
            type: quizTypes.UPDATE_SESSION_LANGUAGE,
            endpoint: "v1/quizzes/session/".concat(sessionUid, "/update_language/"),
            method: "post",
            data: {
                language: languageCode
            }
        });
    };
};
// quiz creation -->
var createTest = function(data, uid) {
    return function(dispatch) {
        return dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .quizTypes.EDIT_QUIZ */ .IQ.EDIT_QUIZ,
            endpoint: "v2/quizzes/me/edit/".concat(uid, "/"),
            method: "post",
            data: data
        });
    };
};
var uploadCSV = function(file, quizUID) {
    return function(dispatch) {
        var data = new FormData();
        data.append("file", file);
        data.append("quiz_uid", quizUID);
        return dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .quizTypes.UPLOAD_CSV */ .IQ.UPLOAD_CSV,
            endpoint: "v1/quizzes/quiz-question/upload/",
            method: "post",
            isFormData: true,
            data: data
        });
    };
};
var fetchReviewStats = function(goalUID) {
    return {
        type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .quizTypes.FETCH_REVIEW_STATS */ .IQ.FETCH_REVIEW_STATS,
        endpoint: "v1/quizzes/quiz-review/get_review_stats/?goal_uid=".concat(goalUID),
        method: "get",
        goalUID: goalUID,
        schema: new normalizr__WEBPACK_IMPORTED_MODULE_3__/* .schema.Object */ .fK.Object({}),
        processData: function(data) {
            return {
                todayCount: data.today_count,
                thisMonthCount: data.this_month_count,
                lastMonthCount: data.last_month_count
            };
        }
    };
};
var getReviews = function(key, resetWithoutEmpty) {
    return function(next) {
        return {
            type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .quizTypes.FETCH_REVIEWS */ .IQ.FETCH_REVIEWS,
            endpoint: next,
            method: "get",
            key: key,
            resetWithoutEmpty: resetWithoutEmpty,
            schema: _schemas__WEBPACK_IMPORTED_MODULE_2__/* .paginatorListSchema */ .EH
        };
    };
};
var fetchReviews = function(goalUID, filter, nextPage) {
    var resetWithoutEmpty = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    return (0,_utils_paginateAction__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("v1/quizzes/quiz-review/get_reviews/?goal_uid=".concat(goalUID, "&status_filter=").concat(filter, "&limit=4"), getReviews("".concat(goalUID, "_").concat(filter), resetWithoutEmpty), "reviewTests", "".concat(goalUID, "_").concat(filter), resetWithoutEmpty)(nextPage);
};
var fetchReviewDashboardGoals = function() {
    return {
        type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .quizTypes.FETCH_DASHBOARD_GOALS */ .IQ.FETCH_DASHBOARD_GOALS,
        endpoint: "v1/quizzes/quiz-review/dashbooard_goals/",
        method: "get"
    };
};
var updateDashboardFilters = function(goal, state, sort, language) {
    return {
        type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .quizTypes.UPDATE_DASHBOARD_FILTERS */ .IQ.UPDATE_DASHBOARD_FILTERS,
        goal: goal,
        state: state,
        sort: sort,
        language: language
    };
};
var fetchPostReviewNotifications = function(quizUID) {
    return {
        type: quizTypes.FETCH_POSTREVIEW_NOTIFICATIONS,
        endpoint: "v1/quizzes/quiz-review/review_notification/?quiz_uid=".concat(quizUID),
        method: "get"
    };
};
var assignReview = function(quiz_uid, reviewer_email) {
    var self_review = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    return {
        type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .quizTypes.ASSIGN_REVIEW */ .IQ.ASSIGN_REVIEW,
        endpoint: "v1/quizzes/quiz-review/assign_review/",
        method: "post",
        data: {
            reviewer_email: reviewer_email,
            quiz_uid: quiz_uid,
            self_review: self_review
        }
    };
};
var assignEvalutor = function(quiz_uid, email) {
    return {
        type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .quizTypes.ASSIGN_EVALUATOR */ .IQ.ASSIGN_EVALUATOR,
        endpoint: "v1/quizzes/subjective-test/assign_quiz/",
        method: "post",
        data: {
            quiz_uid: quiz_uid,
            email: email
        }
    };
};
var assignUploader = function(quiz_uid, email) {
    return {
        type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .quizTypes.ASSIGN_UPLOADER */ .IQ.ASSIGN_UPLOADER,
        endpoint: "v1/quizzes/quiz-upload/assign_uploader/",
        method: "post",
        data: {
            quiz_uid: quiz_uid,
            uploader_email: email
        }
    };
};
var fetchTestEvalDashStats = function(goalUID) {
    return {
        type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .quizTypes.FETCH_EVAL_DASH_STATS */ .IQ.FETCH_EVAL_DASH_STATS,
        endpoint: "v1/quizzes/subjective-test/get_statistics/?goal_uid=".concat(goalUID),
        method: "get",
        goalUID: goalUID,
        schema: new normalizr__WEBPACK_IMPORTED_MODULE_3__/* .schema.Object */ .fK.Object({}),
        processData: function(data) {
            return {
                todayCount: data.today_count,
                thisMonthCount: data.this_month_count,
                lastMonthCount: data.last_month_count
            };
        }
    };
};
var getMyEvals = function(key, resetWithoutEmpty) {
    return function(next) {
        return {
            type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .quizTypes.FETCH_MY_EVALS */ .IQ.FETCH_MY_EVALS,
            endpoint: next,
            method: "get",
            key: key,
            resetWithoutEmpty: resetWithoutEmpty,
            schema: _schemas__WEBPACK_IMPORTED_MODULE_2__/* .paginatorListSchema */ .EH
        };
    };
};
var fetchMyEvals = function(goalUID, filter, language, nextPage) {
    var resetWithoutEmpty = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    return (0,_utils_paginateAction__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("v1/quizzes/subjective-test/get_my_evaluations/?goal_uid=".concat(goalUID, "&status_filter=").concat(filter, "&language_code=").concat(language, "&limit=40"), getMyEvals("".concat(goalUID, "_").concat(filter, "_").concat(language), resetWithoutEmpty), "myEvaluations", "".concat(goalUID, "_").concat(filter, "_").concat(language), resetWithoutEmpty)(nextPage);
};
var getEvaluatedCopies = function(key, resetWithoutEmpty) {
    return function(next) {
        return {
            type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .quizTypes.FETCH_EVALUATED_COPIES */ .IQ.FETCH_EVALUATED_COPIES,
            endpoint: next,
            method: "get",
            key: key,
            resetWithoutEmpty: resetWithoutEmpty,
            schema: _schemas__WEBPACK_IMPORTED_MODULE_2__/* .paginatorListSchema */ .EH
        };
    };
};
var fetchEvaluatedCopies = function(quizUID, sortBy, language, nextPage) {
    var resetWithoutEmpty = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    return (0,_utils_paginateAction__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("v1/quizzes/subjective-test/view_completed_evaluations/?quiz_uid=".concat(quizUID, "&sort_by=").concat(sortBy, "&language_code=").concat(language), getEvaluatedCopies("".concat(quizUID, "_").concat(sortBy), resetWithoutEmpty), "evaluatedCopies", "".concat(quizUID, "_").concat(sortBy), resetWithoutEmpty)(nextPage);
};
var fetchEvalDashboardGoals = function() {
    return {
        type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .quizTypes.FETCH_EVAL_DASH_GOALS */ .IQ.FETCH_EVAL_DASH_GOALS,
        endpoint: "v1/quizzes/subjective-test/get_dashboard_goals/",
        method: "get"
    };
};
var assignEvaluation = function(quiz_uid) {
    return {
        type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .quizTypes.ASSIGN_EVALUATION */ .IQ.ASSIGN_EVALUATION,
        endpoint: "v1/quizzes/subjective-test/assign_evaluation/",
        method: "post",
        data: {
            quiz_uid: quiz_uid
        }
    };
};
var fetchTestSeriesData = function(testSeriesKey) {
    return {
        type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .quizTypes.FETCH_TEST_SERIES_DATA */ .IQ.FETCH_TEST_SERIES_DATA,
        endpoint: "api/test-series/".concat(testSeriesKey, "/"),
        method: "get",
        hostType: _utils_api_helper_host__WEBPACK_IMPORTED_MODULE_0__/* .HOST_TYPE.CMS */ .Bk.CMS,
        testSeriesKey: testSeriesKey
    };
};
var fetchGtpTestSeriesData = function(goalUID) {
    return {
        type: quizTypes.FETCH_GTP_TEST_SERIES_DATA,
        endpoint: "v1/quizzes/gtp/test_series/?goal_uid=".concat(goalUID),
        method: "get"
    };
};
var submitCriteriaScore = function(evaluation_uid, criteria, remarks, evaluated_sheet_url) {
    return {
        type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .quizTypes.SUBMIT_EVALUATION_SCORE */ .IQ.SUBMIT_EVALUATION_SCORE,
        endpoint: "v1/quizzes/subjective-test/give_criteria_score/",
        method: "post",
        data: {
            evaluation_uid: evaluation_uid,
            attributes: {
                criteria: criteria
            },
            remarks: remarks,
            evaluated_sheet_url: evaluated_sheet_url
        }
    };
};
var fetchQuizUploadDashboardGoals = function() {
    return {
        type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .quizTypes.FETCH_QUIZ_UPLOAD_DASHBOARD_GOALS */ .IQ.FETCH_QUIZ_UPLOAD_DASHBOARD_GOALS,
        endpoint: "v1/quizzes/quiz-upload/dashboard_goals/",
        method: "get"
    };
};
var getMyUploads = function(key, resetWithoutEmpty) {
    return function(next) {
        return {
            type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .quizTypes.FETCH_MY_UPLOADS */ .IQ.FETCH_MY_UPLOADS,
            endpoint: next,
            method: "get",
            key: key,
            resetWithoutEmpty: resetWithoutEmpty,
            schema: _schemas__WEBPACK_IMPORTED_MODULE_2__/* .paginatorListSchema */ .EH
        };
    };
};
var fetchMyUploads = function(goalUID, filter, nextPage) {
    var resetWithoutEmpty = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    return (0,_utils_paginateAction__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("v1/quizzes/quiz-upload/my_uploads/?goal_uid=".concat(goalUID, "&status_filter=").concat(filter, "&limit=6"), getMyUploads("".concat(goalUID, "_").concat(filter), resetWithoutEmpty), "myUploads", "".concat(goalUID, "_").concat(filter), resetWithoutEmpty)(nextPage);
};


/***/ }),

/***/ 56217:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ redirectToRoute; }
/* harmony export */ });
/* harmony import */ var _pushRoute__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(751);

// eslint-disable-next-line import/prefer-default-export
var redirectToRoute = function(isServer, res, href, as) {
    var asPath = as || href;
    if (isServer) {
        res.writeHead(302, {
            Location: asPath
        });
        return res.end();
    }
    (0,_pushRoute__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(href, asPath);
    return {};
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [35303,86924,82492,52420,25675,96523,61608,41664,63953,74635,64097,74061,347,35133,35451,9720,46571,89374,94336,4392,72047,32410,3779,1272,22888,49774,92888,40179], function() { return __webpack_exec__(17318); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);